import { useAuth } from 'contexts/auth';
import { useTranslation } from 'react-i18next';
import { Stack, Text } from 'shell/components';

const NoAssignments = (props) => {
    const { auth } = useAuth();
    const { t } = useTranslation('assignment');

    return auth.role === 'instructor' ? (
        <Stack sx={{ mt: '20vh', mx: 'auto', maxWidth: '550px' }} alignItems={'center'} spacing={3} {...props}>
            <svg
                width='250'
                height='105'
                viewBox='0 0 250 105'
                fill='none'
                aria-hidden='true'
                focusable='false'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M207 17C210.866 17 214 20.134 214 24C214 27.866 210.866 31 207 31H167C170.866 31 174 34.134 174 38C174 41.866 170.866 45 167 45H189C192.866 45 196 48.134 196 52C196 55.866 192.866 59 189 59H178.826C173.952 59 170 62.134 170 66C170 68.5773 172 70.9107 176 73C179.866 73 183 76.134 183 80C183 83.866 179.866 87 176 87H93C89.134 87 86 83.866 86 80C86 76.134 89.134 73 93 73H54C50.134 73 47 69.866 47 66C47 62.134 50.134 59 54 59H94C97.866 59 101 55.866 101 52C101 48.134 97.866 45 94 45H69C65.134 45 62 41.866 62 38C62 34.134 65.134 31 69 31H109C105.134 31 102 27.866 102 24C102 20.134 105.134 17 109 17H207ZM207 45C210.866 45 214 48.134 214 52C214 55.866 210.866 59 207 59C203.134 59 200 55.866 200 52C200 48.134 203.134 45 207 45Z'
                    fill='#F0F0F2'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M153.672 15.9997L162.974 83.8424L163.81 90.6487C164.079 92.8414 162.52 94.8372 160.327 95.1064L101.767 102.297C99.5743 102.566 97.5785 101.007 97.3093 98.814L88.2935 25.3865C88.1589 24.2901 88.9386 23.2922 90.0349 23.1576C90.0418 23.1568 90.0488 23.156 90.0557 23.1552L94.9141 22.6102M98.8422 22.1696L103.429 21.655L98.8422 22.1696Z'
                    fill='white'
                />
                <path
                    d='M154.911 15.8299C154.817 15.1459 154.186 14.6675 153.503 14.7613C152.819 14.8551 152.34 15.4855 152.434 16.1695L153.672 15.9997L154.911 15.8299ZM162.974 83.8424L164.215 83.6901C164.214 83.6843 164.213 83.6784 164.213 83.6726L162.974 83.8424ZM163.81 90.6487L165.051 90.4964L163.81 90.6487ZM160.327 95.1064L160.48 96.3471L160.327 95.1064ZM101.767 102.297L101.919 103.537L101.767 102.297ZM97.3093 98.814L98.55 98.6617L97.3093 98.814ZM88.2935 25.3865L87.0529 25.5388L88.2935 25.3865ZM90.0557 23.1552L90.195 24.3974L90.0557 23.1552ZM95.0534 23.8524C95.7394 23.7755 96.2332 23.1569 96.1563 22.4709C96.0793 21.7848 95.4608 21.291 94.7747 21.368L94.9141 22.6102L95.0534 23.8524ZM98.7028 20.9274C98.0168 21.0043 97.523 21.6229 97.6 22.3089C97.6769 22.995 98.2955 23.4887 98.9815 23.4118L98.8422 22.1696L98.7028 20.9274ZM103.569 22.8972C104.255 22.8203 104.748 22.2017 104.671 21.5157C104.594 20.8296 103.976 20.3359 103.29 20.4128L103.429 21.655L103.569 22.8972ZM153.672 15.9997L152.434 16.1695L161.736 84.0122L162.974 83.8424L164.213 83.6726L154.911 15.8299L153.672 15.9997ZM162.974 83.8424L161.734 83.9948L162.569 90.8011L163.81 90.6487L165.051 90.4964L164.215 83.6901L162.974 83.8424ZM163.81 90.6487L162.569 90.8011C162.754 92.3085 161.682 93.6806 160.175 93.8657L160.327 95.1064L160.48 96.3471C163.357 95.9937 165.404 93.3743 165.051 90.4964L163.81 90.6487ZM160.327 95.1064L160.175 93.8657L101.615 101.056L101.767 102.297L101.919 103.537L160.48 96.3471L160.327 95.1064ZM101.767 102.297L101.615 101.056C100.107 101.241 98.7351 100.169 98.55 98.6617L97.3093 98.814L96.0686 98.9663C96.422 101.844 99.0414 103.891 101.919 103.537L101.767 102.297ZM97.3093 98.814L98.55 98.6617L89.5342 25.2341L88.2935 25.3865L87.0529 25.5388L96.0686 98.9663L97.3093 98.814ZM88.2935 25.3865L89.5342 25.2341C89.4837 24.823 89.7761 24.4488 90.1872 24.3983L90.0349 23.1576L89.8826 21.9169C88.101 22.1357 86.8341 23.7572 87.0529 25.5388L88.2935 25.3865ZM90.0349 23.1576L90.1872 24.3983C90.1898 24.398 90.1924 24.3977 90.195 24.3974L90.0557 23.1552L89.9163 21.913C89.9051 21.9142 89.8938 21.9156 89.8826 21.9169L90.0349 23.1576ZM90.0557 23.1552L90.195 24.3974L95.0534 23.8524L94.9141 22.6102L94.7747 21.368L89.9163 21.913L90.0557 23.1552ZM98.8422 22.1696L98.9815 23.4118L103.569 22.8972L103.429 21.655L103.29 20.4128L98.7028 20.9274L98.8422 22.1696Z'
                    fill='#9D9BA7'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M151.14 20.2696L159.559 81.7533L160.317 87.9215C160.561 89.9086 159.167 91.715 157.203 91.9561L104.761 98.3951C102.797 98.6362 101.008 97.2208 100.764 95.2337L92.6139 28.8572C92.4792 27.7608 93.2589 26.7629 94.3552 26.6283L100.843 25.8318'
                    fill='#E2E1E5'
                />
                <path
                    d='M110.672 3.25H156.229C156.958 3.25 157.657 3.53933 158.173 4.05469L171.616 17.4902C172.132 18.0059 172.422 18.7053 172.422 19.4346V82C172.422 83.5188 171.191 84.75 169.672 84.75H110.672C109.153 84.75 107.922 83.5188 107.922 82V6C107.922 4.48122 109.153 3.25 110.672 3.25Z'
                    fill='white'
                    stroke='#9D9BA7'
                    strokeWidth='2.5'
                />
                <path
                    d='M156.672 4.40234V15.9995C156.672 17.6564 158.015 18.9995 159.672 18.9995H167.605'
                    stroke='#9D9BA7'
                    strokeWidth='2.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M118 70H144M118 19H144H118ZM118 31H161H118ZM118 44H161H118ZM118 57H161H118Z'
                    stroke='#BFBEC6'
                    strokeWidth='2.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
            <Text align={'center'} color={'light'} component={'p'} variant={'h6'} weight={'semibold'}>
                {t('create-an-assignment.title', 'Import or Create an Assignment')}
            </Text>
            <Text align={'center'} color={'light'}>
                {t(
                    'create-an-assignment.description',
                    'The details provided during the setup process will guide our AI in providing you with grading and feedback suggestions!'
                )}
            </Text>
        </Stack>
    ) : (
        <Stack sx={{ mt: '20vh', mx: 'auto', maxWidth: '550px' }} alignItems={'center'} spacing={3} {...props}>
            <svg
                width='228'
                height='118'
                viewBox='0 0 228 118'
                fill='none'
                role='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <g clipPath='url(#clip0_4240_30215)'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M188.372 32.0728C191.879 32.0728 194.721 34.9152 194.721 38.4216C194.721 41.928 191.879 44.7704 188.372 44.7704H152.093C155.599 44.7704 158.442 47.6129 158.442 51.1193C158.442 54.6256 155.599 57.4681 152.093 57.4681H172.047C175.553 57.4681 178.395 60.3106 178.395 63.8169C178.395 67.3233 175.553 70.1658 172.047 70.1658H162.819C158.398 70.1658 154.814 73.0083 154.814 76.5146C154.814 78.8522 156.628 80.9685 160.256 82.8635C163.762 82.8635 166.605 85.7059 166.605 89.2123C166.605 92.7187 163.762 95.5611 160.256 95.5611H84.9768C81.4704 95.5611 78.628 92.7187 78.628 89.2123C78.628 85.7059 81.4704 82.8635 84.9768 82.8635H49.6047C46.0983 82.8635 43.2559 80.021 43.2559 76.5146C43.2559 73.0083 46.0983 70.1658 49.6047 70.1658H85.8838C89.3901 70.1658 92.2326 67.3233 92.2326 63.8169C92.2326 60.3106 89.3901 57.4681 85.8838 57.4681H63.2093C59.703 57.4681 56.8605 54.6256 56.8605 51.1193C56.8605 47.6129 59.703 44.7704 63.2093 44.7704H99.4884C95.9821 44.7704 93.1396 41.928 93.1396 38.4216C93.1396 34.9152 95.9821 32.0728 99.4884 32.0728H188.372ZM188.372 57.4681C191.879 57.4681 194.721 60.3106 194.721 63.8169C194.721 67.3233 191.879 70.1658 188.372 70.1658C184.866 70.1658 182.023 67.3233 182.023 63.8169C182.023 60.3106 184.866 57.4681 188.372 57.4681Z'
                        fill='#D3D2D7'
                    />
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M91.2732 93.9218L92.6246 93.875V112.92C92.6246 113.351 92.9755 113.701 93.4082 113.701H140.426C140.859 113.701 141.21 113.351 141.21 112.92V47.6321C141.21 46.0517 139.923 44.7705 138.336 44.7705H95.4979C93.911 44.7705 92.6246 46.0517 92.6246 47.6321V61.2074L91.2732 61.1606C91.1145 61.1551 90.9555 61.1523 90.7962 61.1523C82.6015 61.1523 75.9072 68.4644 75.9072 77.5412C75.9072 86.618 82.6015 93.93 90.7962 93.93C90.9555 93.93 91.1145 93.9273 91.2732 93.9218ZM91.423 87.6617C91.215 87.6783 91.0059 87.6867 90.7962 87.6867C85.8499 87.6867 81.9325 83.102 81.9325 77.5412C81.9325 71.9804 85.8499 67.3957 90.7962 67.3957C91.0059 67.3957 91.215 67.4041 91.423 67.4207L92.6246 67.5167V87.5657L91.423 87.6617Z'
                        fill='#FAFAFB'
                        stroke='#9D9BA7'
                        strokeWidth='2.26744'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M133.954 50.3772V66.9915M133.954 72.1446V76.4466V72.1446Z'
                        stroke='#BFBEC6'
                        strokeWidth='2.26744'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M61.5112 106.445H67.744M164.907 106.445H167.511M146.651 106.445H160.644M73.1859 106.445H89.0164'
                        stroke='#9D9BA7'
                        strokeWidth='2.26744'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M116.721 4.86353C114.303 8.68511 113.093 12.0107 113.093 14.8403C113.093 19.8796 117.314 22.1364 117.314 27.5951C117.314 30.3656 115.907 33.1165 113.093 35.8478'
                        stroke='#BFBEC6'
                        strokeWidth='2.26744'
                        strokeLinecap='round'
                    />
                    <path
                        d='M105.837 14.8403C105.046 19.8402 108.558 20.7649 108.558 25.2475C108.558 27.5226 107.651 29.7978 105.837 32.0729'
                        stroke='#BFBEC6'
                        strokeWidth='2.26744'
                        strokeLinecap='round'
                    />
                    <path
                        d='M122.884 12.5493C121.686 15.6504 122.359 17.5407 122.884 18.6533C124.006 21.0314 125.791 23.0843 125.791 25.5043C125.791 28.315 124.822 31.02 122.884 33.6193'
                        stroke='#BFBEC6'
                        strokeWidth='2.26744'
                        strokeLinecap='round'
                    />
                    <path
                        d='M95.8604 49.3054C95.8604 48.8045 96.2664 48.3984 96.7673 48.3984L114 48.3984V110.98H96.7673C96.2664 110.98 95.8604 110.574 95.8604 110.073V49.3054Z'
                        fill='#E2E1E5'
                    />
                </g>
                <defs>
                    <clipPath id='clip0_4240_30215'>
                        <rect width='226.744' height='117' fill='white' transform='translate(0.62793 0.328613)' />
                    </clipPath>
                </defs>
            </svg>
            <Text align={'center'} color={'light'} component={'p'} variant={'h6'} weight={'semibold'}>
                {t('no-assignments.title', 'No Assignments Yet')}
            </Text>
            <Text align={'center'} color={'light'}>
                {t(
                    'no-assignments.description',
                    "Looks like your instructor hasn't published any assignments. Check back later when your instructor has made them available."
                )}
            </Text>
        </Stack>
    );
};

export default NoAssignments;
